document.addEventListener("DOMContentLoaded", () => {
  // 监听总价的变化,修改价格购物车信息
  var $AnnPrice = $(".ann-nav-list .cart_icon .total_price .money")
  var $AnnCount = $(".ann-nav-list .cart_icon .cart_count")
  var $CartPrice = $(".totals__total-value .money")
  var $CartCount = $(".totals__total-value")

  const originPirceObserver = new MutationObserver(function (mutationsList,observer) {
    $AnnPrice.text($CartPrice.text());
    $AnnCount.text("(" + $CartCount.data("item-count") + ")");
  });

  originPirceObserver.observe(document.querySelector("#cart-icon-bubble"), {
    attributes: true,
    childList: true,
    subtree: true,
  });

  // 跳转顶部
  var $Hmtl = $("html,body")
  
  $(".ann-top-btn").click(function () {
    $Hmtl.animate({ scrollTop: 0 }, 300);
  });

});
